<template>
  <div class="appointmentList-view">
    <!-- 模块展示 -->
    <p class="fs9 fwbold mb20">{{ $t('miniprogram', 'moduleDisplay') }}</p>
    <div class="bgf5f6 pb20 pt20 pl10 flex-a-c mb20">
      <el-checkbox-group v-model="checkList" class="mr20">
        <el-checkbox :label="$t('miniprogram', 'mallTemplate')" disabled></el-checkbox>
        <el-checkbox :label="$t('miniprogram', 'appointmentTemplate')"></el-checkbox>
      </el-checkbox-group>
      <p class="lineheight0 fs6">
        {{ $t('miniprogram', 'canSelectAllOrOnlyShowMallModule') }}
      </p>
    </div>
    <!-- 商城模块 -->
    <p class="fs9 fwbold mb20">{{ $t('miniprogram', 'mallModule') }}</p>
    <div class="bgf5f6 pb20 pt20 pl10 flex-a-c mb20" v-if="currentType == 0">
      <p class="lineheight0 fs7 mr20">
        {{ $t('miniprogram', 'moduleName') }}
      </p>
      <el-input type="text"  
                class="w200 "
                v-model="shopName"
                maxlength="4"
                show-word-limit>
      </el-input>
    </div>

    <div class="d-flex mb20 pl10">
      <p class="fs7 mr20">
        {{ $t('miniprogram', 'moduleStyle') }}
      </p>
      <div class="">
        <p class="fs7 mr20 fwbold mb20">
          {{ $t('miniprogram', 'currentStyle') }}：{{templateTitle}}   
        </p>
        <el-button size="small" @click="templateDialog = true" type="primary">{{ $t('miniprogram', 'changeStyle') }}</el-button>
      </div>
      
    </div>
    <div v-if="currentType == 0 ">
      <div class="d-flex  pl10">
        <div class="fs7 mr10" style="width:70px">
          {{ $t('miniprogram', 'topCarousel') }}
        </div>
        <div class="d-flex flex-wrap-y" style="width:1440px">

          <div class="bgf7fa pa10 d-flex align-items-center mr20 mb20 posre"  v-for="(item,index) in  mallBanner" :key="index">
            <div class="d-flex flex-column align-items-center ">
              <el-upload
                    accept="image/jpeg,image/png"
                    class="addTabIcon"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="bannerSuccess.bind(null, {'index':index,'data':item})"
                    :before-upload="beforeUploadImageDynamicPic">
                <img v-if="item.img" :src="item.img" class="avatar dynamic">
                <i v-else class="el-icon-plus"></i>
                
            </el-upload>
            <p class="fs6">{{ $t('miniprogram', 'imageUploadNote750x422') }}</p>
            </div>
            <jumpSet :title="item.title"
                    :index="index"
                    :currentGoods="item"
                    :goodsData="item"
                    @select_tap="select_tap"></jumpSet>
            <i class="el-icon-delete posab fs9 hover_pointer" 
              v-if="index !== 0"
              @click="deleteImg(index)"
              style="bottom:10px;right:10px"></i>
            <el-button size="small"
                      type="primary" 
                      class="posab" 
                      style="right:-110px"
                      @click="addImg"
                      v-if="mallBanner.length - 1  == index &&  index !== 5">
              {{ $t('miniprogram', 'addImage') }}
            </el-button>
          </div>
        </div>
        
      </div>
      
      
     
    </div>
    <!-- 预约模块 -->
    <div v-if="!onlyStore">
      <p class="fs9 fwbold mb20">{{ $t('miniprogram', 'appointmentModule') }}</p>
      <div class="bgf5f6 pb20 pt20 pl10 flex-a-c mb20">
        <p class="lineheight0 fs7 mr20">
          {{ $t('miniprogram', 'moduleName') }}
        </p>
        <el-input type="text"  
                  class="w200 "
                  v-model="reservationName"
                  maxlength="4"
                  show-word-limit>
        </el-input>
      </div>
      
      <div class="d-flex  pl10">
        <div class="fs7 mr10" style="width:70px">
          {{ $t('miniprogram', 'topCarousel') }}
        </div>
        <div class="d-flex flex-wrap-y" style="width:1440px">

          <div class="bgf7fa pa10 d-flex align-items-center mr20 mb20 posre"  v-for="(item,index) in  appointmentBanner" :key="index">
            <div class="d-flex flex-column align-items-center ">
              <el-upload
                    accept="image/jpeg,image/png"
                    class="addTabIcon"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="bannerSuccess.bind(null, {'index':index,'data':item,'type':'b'})"
                    :before-upload="beforeUploadImageDynamicPic">
                <img v-if="item.img" :src="item.img" class="avatar dynamic">
                <i v-else class="el-icon-plus"></i>
                
            </el-upload>
            <p class="fs6">{{ $t('miniprogram', 'imageUploadNote750x422') }}</p>
            </div>
            <jumpSet :title="item.title"
                    :index="index"
                    :goodsData="item"
                    :type="'appointment'"
                    :currentGoods="item"
                    @select_tap="select_tap"></jumpSet>
            <i class="el-icon-delete posab fs9 hover_pointer" 
              v-if="index !== 0"
              @click="deleteImg(index,'b')"
              style="bottom:10px;right:10px"></i>
            <el-button size="small"
                      type="primary" 
                      class="posab" 
                      style="right:-110px"
                      @click="addImg('b')"
                      v-if="appointmentBanner.length - 1  == index &&  index !== 5">
              {{ $t('miniprogram', 'addImage') }}
            </el-button>
          </div>
        </div>
      </div>

    </div>
    <div class="flex-j-c">
      <el-button size="small"
                type="primary" 
                @click="saveImg">
            {{ $t('miniprogram', 'save') }}
      </el-button>
    </div>
    <el-dialog :title="$t('miniprogram', 'selectStyle')" 
               :center="true"
               width="80%"
               :modal-append-to-body="false"
               :visible="templateDialog"
               @close="templateDialogClose">
          <p class="fs8 mb20 text-align">{{ $t('miniprogram', 'styleSelectionDescription') }}</p>
          <div class="d-flex justify-content-between">
              <div class="d-flex hover_pointer flex-column"
                   style="height:600px "
                   v-for="(item,index) in storeTemplate" 
                   @click="selectTemplate(item)"
                   :key="index">
                <div class="flex1 oyauto imgScroll shadow-gray50"> 
                  <img :src="item.img" class="w240" alt="">
                </div>
                <div class="bgfff text-align borderbox pt20" style="height:100px;">
                  <div class="h40" style="line-height: 40px;">
                    <div class="" style="line-height: 40px;">
                      <p class="fs9 cblue" v-if="index !== 0" @click.stop="editTemplate(item)">{{ $t('miniprogram', 'editContent') }}</p>
                    </div>
                  </div>
                  <el-radio :label="item.title" size="medium" v-model="currentTitle" @change="goodsTypeRow(scope.$index,scope.row)"></el-radio>
                </div>
              </div>
          </div>
        <div class="d-flex justify-content-center">
           <el-button size="medium"
                      plain
                      class="mr100"
                      @click="cancel">
                        {{ $t('miniprogram', 'cancel') }}
            </el-button>
            <el-button size="medium"
                       type="primary" 
                       @click="confirm">
                        {{ $t('miniprogram', 'confirm') }}
            </el-button>
        </div> 
    </el-dialog>
  </div>
</template>

<script>
import {
  queryShopModelConfigAll,
  queryShopConfig,
  saveShopConfig
} from "@/api/wechat";
import { getDataTimeSec } from "@/utils";
import jumpSet from "./components/jumpSet";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  mixins: [i18nMixin],
  data() {
    return {
      checkList:[this.$t('miniprogram', 'mallTemplate'),this.$t('miniprogram', 'appointmentTemplate')],
      // 可修改的原始数据
      shopNameData: this.$t('miniprogram', 'productMall'),
      reservationNameData: this.$t('miniprogram', 'appointmentService'),
      uploadUrl:this.$store.state.uploadingUrl,
      ossUrl:this.$store.state.ossUrl,
      // 可修改的banner数据
      mallBannerData:[{
        img:"https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/product-index/20190418160834.png",
        title:"无"
      }],
      appointmentBannerData:[{
        img:"https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/product-index/20190418160834.png",
        title:"无"
      }],
      storeTemplate:[{
        title: this.$t('miniprogram', 'simpleMode'),
        type:0,
        img:require('../../../src/static/bg1.jpg'),
      },{
        title: this.$t('miniprogram', 'comprehensiveEcommerce'),
        type:'ecommerce',
        img:require('../../../src/static/bg2.png')
      },{
        title: this.$t('miniprogram', 'festivalDiscount'),
        type:'holiday_offer',
        img:require('../../../src/static/bg3.png')
      },{
        title: this.$t('miniprogram', 'dailyNecessities'),
        type:'daily_necessities',
        img:require('../../../src/static/bg4.png')
      },{
        title: this.$t('miniprogram', 'digitalAppliances'),
        type:'digital_appliances',
        img:require('../../../src/static/bg5.png')
      }],
      templateDialog:false, // 商城模板
      currentTitle: this.$t('miniprogram', 'simpleMode'),
      currentType:0 ,
      templateTitle: this.$t('miniprogram', 'simpleMode'),
      templateType:0,
      onlyStore:false,
      allConfig:''
    };
  },
  computed: {
    // 商城轮播图数据，响应语言变化
    mallBanner() {
      return this.mallBannerData.map(item => ({
        ...item,
        title: item.title === "无" ? this.$t('miniprogram', 'no') : item.title
      }));
    },
    // 预约轮播图数据，响应语言变化
    appointmentBanner() {
      return this.appointmentBannerData.map(item => ({
        ...item,
        title: item.title === "无" ? this.$t('miniprogram', 'no') : item.title
      }));
    },
    // 商城模块名称
    shopName() {
      return this.shopNameData;
    },
    // 预约模块名称
    reservationName() {
      return this.reservationNameData;
    },
    // 选项列表，响应语言变化
    optionList() {
      return [
        {
          text: this.$t('miniprogram', 'no'),
        },
        {
          text: this.$t('miniprogram', 'ordinaryGoods'),
        },
        {
          text: this.$t('miniprogram', 'flashSaleGoods'),
        },
        {
          text: this.$t('miniprogram', 'groupBuyGoods'),
        },
        {
          text: this.$t('miniprogram', 'distributionGoods'),
        },
        {
          text: this.$t('miniprogram', 'businessCardPage'),
        },
        {
          text: this.$t('miniprogram', 'mediaPage'),
        },
        {
          text: this.$t('miniprogram', 'mallPage'),
        },
        {
          text: this.$t('miniprogram', 'dynamicPage'),
        },
        {
          text: this.$t('miniprogram', 'officialWebsitePage'),
        },
      ];
    },
  },
  components:{
    jumpSet,
  },
  watch:{
    checkList(newVal){
      if(newVal.length == 1){
        this.onlyStore = true
      }else{
        this.onlyStore = false
      }
    }
  },
  created(){
    this.queryConfig()
    this.queryShopConfigAll()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听，添加安全检查
    if (this.$root) {
      this.$root.$off('language-changed');
    }
  },
  methods:{
    queryConfig(){
      let than = this 
      let data = {
        ignore:1
      }
      queryShopConfig(data)
      .then(res=>{
        let than = this
        if(!res.data){
          return
        }
        if(JSON.parse(res.data.shopTop)){
          than.$set(than,'mallBannerData', JSON.parse(res.data.shopTop))
        }
        if(JSON.parse(res.data.reservationTop)){
          than.$set(than,'appointmentBannerData', JSON.parse(res.data.reservationTop))
        }
        than.shopNameData = res.data.shopName
        than.reservationNameData = res.data.reservationName
        if(res.data.showReservation){
          than.checkList = [this.$t('miniprogram', 'mallTemplate'),this.$t('miniprogram', 'appointmentTemplate')]
        }else{
          than.checkList = [this.$t('miniprogram', 'mallTemplate')]
        }
        than.currentType = res.data.shopTemplate
        than.storeTemplate.forEach(item=>{  
          if(than.currentType == item.type){
            than.currentTitle = item.title
            than.templateTitle = item.title
          }
        }) 
      })
    },
    queryShopConfigAll(){
      let data = {
        ignore:true
      }
      queryShopModelConfigAll(data)
      .then(res=>{
        this.allConfig = res.data
      })
    },
    addImg(type){
      if(type !== 'b'){
        this.mallBannerData.push({
          title: this.$t('miniprogram', 'no'),
          img:'',
        })
      }else{
        this.appointmentBannerData.push({
          title: this.$t('miniprogram', 'no'),
          img:'',
        })
      }
    },
    deleteImg(index,type){
      if(type !== 'b'){
        this.mallBannerData.splice(index,1)
      }else{
        this.appointmentBannerData.splice(index,1)
      }
    },
    select_tap(index,val,type,goods,apptype){
      if(type !== 'appointment'){//商城
        
        this.mallBannerData[index].title = val
        if(goods){
          this.mallBannerData[index].goods = goods
          delete this.mallBannerData[index].page
        }else{
          delete this.mallBannerData[index].goods 
          this.mallBannerData[index].page = type
        }
      }else{//预约
        this.appointmentBannerData[index].title = val
        if(goods){
          this.appointmentBannerData[index].goods = goods
          delete this.appointmentBannerData[index].page 
        }else{
          delete this.appointmentBannerData[index].goods 
          this.appointmentBannerData[index].page = apptype
        }
      }
      
    },
    bannerSuccess(obj,res,file){
      //动态图上传成功
      if(!obj.type){
        var index = obj.index;
        this.$set(this.mallBannerData[index],'img',this.ossUrl + '/' + res.data)
      }else{
        var index = obj.index;
        this.$set(this.appointmentBannerData[index],'img',this.ossUrl + '/' + res.data)
      }
      
    },
    beforeUploadImageDynamicPic(file){
      var _this = this;
      var isLt10M = file.size / 1024 / 1024  < 10;
      if (['image/jpeg', 'image/png'].indexOf(file.type) == -1) {
          _this.$message.error(this.$t('miniprogram', 'uploadCorrectImageFormat'))
          return false;
      }
      if (!isLt10M) {
          _this.$message.error(this.$t('miniprogram', 'uploadImageSizeLimit'))
          return false;
      }
    },
    selectTemplate(item){
      this.currentTitle = item.title
      this.currentType = item.type
    },
    // 保存模板
    saveImg(){
      let than = this
      let marr = JSON.parse(JSON.stringify(than.mallBannerData))
      let appArr = JSON.parse(JSON.stringify(than.appointmentBannerData))
      // if(than.currentType == 0){
      //   if(!than.onlyStore){
          
      //   }else{
      //     appArr = ''
      //     than.reservationName = ''
      //   }
      // }else{
      //   appArr = ''
      //   than.reservationName = ''
      //   marr = ''
      //   than.shopName = ''
      // }
      let data = {
        reservationName:than.reservationNameData,
        reservationTop:JSON.stringify(appArr),
        shopTemplate:than.currentType,
        shopName:than.shopNameData,
        shopTop:JSON.stringify(marr),
        showShop:true,
        showReservation:!than.onlyStore,
      }
      saveShopConfig(data)
      .then(res=>{
        than.$message.success(this.$t('miniprogram', 'saveSuccessful'))
      })
    },
    templateDialogClose(){
      this.templateDialog = false // 商城模板
      
    },
    //取消选择模板 恢复默认值
    cancel(){
      this.currentTitle = this.$t('miniprogram', 'simpleMode')
      this.currentType = 0
      this.templateDialog = false
    },
    //确定模板
    async confirm(){
     let data = {
        ignore:true
      }
      let allConfig = await queryShopModelConfigAll(data)
      if( this.currentType !== 0){
        if(!allConfig.data){
          return this.$message.error(this.$t('miniprogram', 'templateNeedConfigureContentBeforeSave'))
        }
        this.allConfig = allConfig.data
        this.templateTitle = this.currentTitle
        this.templateType = this.currentType
        let isReturn = true
        this.allConfig.forEach(item=>{
          if(item.modelEnum == this.currentType){
            isReturn = false
          }
        })
        if(isReturn && this.currentType !== 0){
          return this.$message.error(this.$t('miniprogram', 'templateNeedConfigureContentBeforeSave'))
        }
      }
      
      
      this.templateDialog = false
    },
    editTemplate(item){
      this.currentTitle = item.title
      this.currentType = item.type
      
      switch (this.currentType) {
        case 'ecommerce':
          this.$router.push('/templateA'  )
          break;
        case 'holiday_offer':
          this.$router.push('/templateB'  )
          break;
        case 'daily_necessities':
          this.$router.push('/templateC'  )
          break;
        case 'digital_appliances':
          this.$router.push('/templateD'  )
          break;
        default:
          break;
      }
      
    },
  }
};
</script>

<style lang="scss" scoped>
.appointmentList-view{
  background: #fff;
  padding:30px;
}
 /deep/.addTabIcon .el-upload--text{
  width: 210px;
  height: 100px;
  line-height: 100px;
  margin-bottom: 10px;
}
/deep/ .addTabIcon .el-upload-list__item {
  width: 210px;
  height: 100px;
  line-height: 100px;

}
/deep/ .el-radio__inner{
  width: 20px;
  height: 20px;
}
/deep/ .el-radio__label{
  font-size: 16px;
}
.avatar{
  width: 100%;
  height: 100%;
}
.imgScroll::-webkit-scrollbar { width: 0 !important }
</style>